import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Подать заявку',
  description: 'Подайте заявку и с вами свяжется наш финансовый менеджер и проконсультирует по всем вопросам',
  form: {
    agreements: {
      text: 'Нажатие на кнопку "Отправить" подтверждает ваше согласие на передачу данных, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в {link}',
      link: 'ООО МКК "Поле Инвест"',
    },
    actions: {
      sent: 'Отправить',
    },
  },
} satisfies TMessages
